
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Panveltopunecab() {



    const cardData =
    {
        keyword: ' Panvel to Pune Cab',
        heading: 'Skyline Cabs: Panvel to Pune Cab',
        headingDescription: 'Skyline Cabs offers dependable and comfortable Panvel to Pune Cab service for a smooth intercity travel experience. Whether you are heading to Pune for business, leisure, or a family visit, our clean and well-maintained cabs driven by experienced chauffeurs ensure a safe and relaxing journey. With on-time pickups from Panvel, transparent pricing, and 24/7 customer support, Skyline Cabs is your trusted travel partner. Book your Panvel to Pune cab today and enjoy a convenient, stress-free ride.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
  {
    "name": "Panvel Station to Pune Taxi",
    "description": "Skyline Cabs offers reliable and affordable taxi services from Panvel Station to Pune. Our professional drivers ensure a smooth and comfortable ride, whether it's a one-way trip or a round trip, with competitive pricing and flexible options."
  },
  {
    "name": "Panvel to Pune Cab Charges",
    "description": "Skyline Cabs provides transparent pricing for your taxi ride from Panvel to Pune. We offer competitive and affordable cab charges, ensuring no hidden fees and a clear breakdown of the cost for your journey."
  },
  {
    "name": "Panvel to Pune Cab Fare",
    "description": "Skyline Cabs offers clear and affordable fare rates for trips from Panvel to Pune. Our taxis come with professional drivers who will make sure your journey is comfortable, safe, and within your budget."
  },
  {
    "name": "Panvel to Pune Distance Taxi Fare",
    "description": "For your journey from Panvel to Pune, Skyline Cabs offers distance-based taxi fare pricing, ensuring that you get the most accurate and affordable cost based on the travel distance. Book your ride for a hassle-free experience."
  },
  {
    "name": "Panvel to Pune Taxi",
    "description": "Skyline Cabs provides dependable and safe taxi services from Panvel to Pune. Choose from a variety of vehicles based on your needs, including Innova, Ertiga, and sedan options for a comfortable and affordable ride."
  },
  {
    "name": "Panvel to Pune Taxi Fare",
    "description": "Skyline Cabs offers competitive taxi fare rates for trips from Panvel to Pune, ensuring a transparent pricing structure with no hidden charges. Book your ride with us for a comfortable journey."
  },
  {
    "name": "Panvel to Pune Innova Cab",
    "description": "Skyline Cabs provides premium Innova Crysta taxis for your journey from Panvel to Pune. With ample space and luxury features, the Innova Crysta ensures a comfortable and smooth ride for your group or family."
  },
  {
    "name": "Panvel to Pune One Way Cab",
    "description": "For a one-way journey from Panvel to Pune, Skyline Cabs offers affordable and comfortable one-way cab services. Our taxis are well-maintained, ensuring a smooth and relaxed ride to your destination."
  },
  {
    "name": "Panvel to Pune Round Trip Cab",
    "description": "Skyline Cabs offers round trip taxi services from Panvel to Pune, ensuring a hassle-free travel experience. Book your round trip cab and enjoy flexible pick-up and drop-off times for your convenience."
  },
  {
    "name": "Panvel to Pune Station Cab Fare",
    "description": "Skyline Cabs offers competitive pricing for taxi rides from Panvel to Pune Station. Whether you're catching a train or traveling for business, our drivers will ensure you arrive comfortably and on time."
  },
  {
    "name": "Panvel to Baner Cab",
    "description": "Book a taxi from Panvel to Baner with Skyline Cabs for a comfortable and reliable journey. We offer flexible vehicles to meet your needs, ensuring you have a pleasant trip at competitive rates."
  },
  {
    "name": "Panvel to Hinjewadi Cab",
    "description": "Skyline Cabs provides reliable and affordable taxi services for your journey from Panvel to Hinjewadi. Whether it's for work or leisure, our experienced drivers will ensure a smooth and comfortable ride."
  },
  {
    "name": "Panvel to Pune Ertiga Cab",
    "description": "Skyline Cabs offers Ertiga taxis for your trip from Panvel to Pune, providing ample space and comfort. Whether you're traveling with family or friends, enjoy a smooth and relaxing journey in our well-maintained vehicles."
  },
  {
    "name": "Panvel to Pune Taxi",
    "description": "Skyline Cabs provides efficient and reliable taxi services from Panvel to Pune. With a variety of vehicles to choose from, our services are designed to offer comfort, affordability, and safety for your journey."
  },
  {
    "name": "Cab Service in Panvel",
    "description": "Skyline Cabs offers dependable taxi services in Panvel for local, outstation, and airport rides. Whether you need a quick ride to the station or a long-distance journey, we have the right vehicle for you."
  },
  {
    "name": "Panvel Outstation Taxi Service",
    "description": "Skyline Cabs provides reliable outstation taxi services from Panvel to various destinations. Whether you're traveling to Pune, Mumbai, or other locations, we offer affordable and safe rides with well-maintained vehicles."
  },
  {
    "name": "Cheapest Taxi Service in Panvel",
    "description": "Skyline Cabs offers the cheapest taxi services in Panvel, ensuring you get the best value for your money. Our transparent pricing and excellent customer service make us the preferred choice for budget-friendly travel."
  },
  {
    "name": "Taxi Service in Churchgate",
    "description": "Skyline Cabs offers taxi services from Churchgate to various locations across Mumbai and beyond. Book your ride with us for a reliable, comfortable, and affordable experience with our fleet of well-maintained vehicles."
  }
],
"tableData": [
  ["Panvel Station to Pune Taxi", "Panvel to Pune Cab Charges"],
  ["Panvel to Pune Cab Fare", "Panvel to Pune Distance Taxi Fare"],
  ["Panvel to Pune Taxi", "Panvel to Pune Taxi Fare"],
  ["Panvel to Pune Innova Cab", "Panvel to Pune One Way Cab"],
  ["Panvel to Pune Round Trip Cab", "Panvel to Pune Station Cab Fare"],
  ["Panvel to Baner Cab", "Panvel to Hinjewadi Cab"],
  ["Panvel to Pune Ertiga Cab", "Panvel to Pune Taxi"],
  ["Cab Service in Panvel", "Panvel Outstation Taxi Service"],
  ["Cheapest Taxi Service in Panvel", "Taxi Service in Churchgate"]
],



whychoose: [
    {
        "WhyChooseheading": "Reliable Panvel to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers reliable and timely cab services from Panvel to Pune. Whether it's for business, leisure, or any other purpose, we ensure a smooth and comfortable journey every time."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet of well-maintained vehicles includes sedans, SUVs, and luxury cars, designed to provide a comfortable and relaxing ride from Panvel to Pune. All our vehicles are air-conditioned, spacious, and equipped with modern amenities."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Skyline Cabs employs experienced and professional drivers who are familiar with the best routes from Panvel to Pune. They prioritize your comfort, safety, and punctuality, ensuring you have a stress-free trip."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "With Skyline Cabs, you’ll always know the cost upfront. Our competitive pricing ensures you get excellent value for your Panvel to Pune cab journey with no hidden charges."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Skyline Cabs operates 24/7, meaning you can book your cab from Panvel to Pune at any time of the day or night. Whether it’s a planned trip or a last-minute journey, we are always ready to serve you."
    },
    {
        "WhyChooseheading": "Easy and Quick Online Booking",
        "WhyChoosedescription": "Booking a cab is easy and fast with Skyline Cabs. Use our website or mobile app to book your ride in just a few clicks, and receive instant booking confirmation along with real-time tracking of your ride."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Cabs",
        "WhyChoosedescription": "Your health and safety are our priority. All our vehicles are sanitized before each ride, and our drivers follow strict safety protocols to ensure a secure and hygienic travel experience."
    },
    {
        "WhyChooseheading": "Variety of Vehicles to Suit Your Needs",
        "WhyChoosedescription": "Whether you're traveling alone, with family, or in a group, Skyline Cabs offers a variety of vehicles for your Panvel to Pune trip. From sedans for a solo ride to spacious SUVs for larger groups, we have options for every need."
    }
]

























    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Panvel to Pune with Skyline Cabs?',
            answer:
                'Booking a cab from Panvel to Pune is quick and easy with Skyline Cabs. You can book through our website, mobile app, or by calling our customer support. Simply provide your pickup and drop-off details, select your preferred vehicle, and confirm your booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Panvel to Pune trip?',
            answer:
                'Skyline Cabs offers a variety of vehicles for your trip, including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Choose the vehicle based on your group size and comfort preferences.',
        },
        {
            id: 3,
            question: 'How long will it take to travel from Panvel to Pune?',
            answer:
                'The travel time from Panvel to Pune usually takes about 3.5 to 5 hours, depending on traffic conditions. Our drivers ensure a smooth and timely journey by choosing the best routes.',
        },
        {
            id: 4,
            question: 'Are the fares for the Panvel to Pune cab fixed?',
            answer:
                'Yes, Skyline Cabs offers fixed pricing with no hidden charges. The fare includes tolls, taxes, and driver fees, so you know the total cost upfront before confirming your booking.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab from Panvel to Pune?',
            answer:
                'Yes, you can book a round-trip cab from Panvel to Pune. Just provide your return trip details during the booking, and we’ll ensure a smooth and comfortable round trip for you.',
        },
        {
            id: 6,
            question: 'Can I modify or cancel my Panvel to Pune cab booking?',
            answer:
                'Yes, you can modify or cancel your booking through our website, mobile app, or by contacting customer support. We offer flexible options to meet your needs.',
        },
        {
            id: 7,
            question: 'Are the vehicles for Panvel to Pune well-maintained?',
            answer:
                'Absolutely! We ensure that all our vehicles are regularly serviced, cleaned, and maintained to ensure comfort and safety throughout your journey.',
        },
        {
            id: 8,
            question: 'What payment options are available for my Panvel to Pune ride?',
            answer:
                'We offer secure online payment options, including credit/debit cards, UPI, and net banking. Alternatively, you can also pay in cash at the end of your ride.',
        },
        {
            id: 9,
            question: 'Is Skyline Cabs suitable for corporate travel from Panvel to Pune?',
            answer:
                'Yes, Skyline Cabs offers corporate travel services, ensuring timely and comfortable transport for business meetings, conferences, and group travel. Contact us for customized corporate packages.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Panvel to Pune journey?',
            answer:
                'Skyline Cabs is known for its punctual service, professional drivers, well-maintained vehicles, and transparent pricing. We ensure a comfortable and hassle-free journey from Panvel to Pune.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "I traveled from Panvel to Pune with Skyline Cabs, and the experience was great. The driver was punctual, the car was clean, and the ride was smooth. Highly recommend!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Good service! The ride from Panvel to Pune was comfortable. The driver was courteous, and the car was well-maintained. A bit of traffic, but overall a smooth trip."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Panvel to Pune Cab",
  "image": "https://skylinecabs.com/assets/images/panvel-to-pune-cab.jpg",
  "description": "Book Panvel to Pune cab with Skyline Cabs for a reliable and comfortable journey. Choose from AC sedans, SUVs, or luxury cars — all with verified drivers and 24/7 availability for one-way or round-trip travel.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7284"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/panvel-to-pune-cab"
  }
};


      
    


    return (
        <div>
<Helmet>
  <title>Panvel to Pune Cab | One-Way & Round Trip | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Panvel to Pune cab with Skyline Cabs for a reliable and comfortable journey. Choose from AC sedans, SUVs, or luxury cars — all with verified drivers and 24/7 availability for one-way or round-trip travel." 
  />
  <meta 
    name="keywords" 
    content="Panvel to Pune Cab, Cab from Panvel to Pune, One-Way Taxi Panvel to Pune, Round Trip Cab Panvel to Pune, AC Cab Panvel to Pune, SUV Taxi Panvel to Pune, Online Cab Booking Panvel to Pune, 24/7 Taxi Panvel Pune, Skyline Cabs Panvel to Pune, Affordable Cab Panvel to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/57.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Panveltopunecab;